/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Probability distributions over the supplied candidates and verbs.
 */
export type LauncherJudgment = {
  /**
   * Probability that the query asks for each of open, enable, disable, publish or unclear.
   */
  action?: { [k: string]: number } | undefined;
  /**
   * True when no intent service is configured; the other fields are then absent. When false, target, action, ready and latency_ms are always present.
   */
  disabled: boolean;
  /**
   * Round trip time to the intent service in milliseconds.
   */
  latencyMs?: number | undefined;
  /**
   * Probability that the query is unambiguous enough to act on the best candidate on Enter.
   */
  ready?: number | undefined;
  /**
   * Probability that each candidate id, or 'none', is the item the user means.
   */
  target?: { [k: string]: number } | undefined;
};

/** @internal */
export const LauncherJudgment$inboundSchema: z.ZodMiniType<
  LauncherJudgment,
  unknown
> = z.pipe(
  z.object({
    action: z.optional(z.record(z.string(), z.number())),
    disabled: z.boolean(),
    latency_ms: z.optional(z.int()),
    ready: z.optional(z.number()),
    target: z.optional(z.record(z.string(), z.number())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "latency_ms": "latencyMs",
    });
  }),
);

export function launcherJudgmentFromJSON(
  jsonString: string,
): SafeParseResult<LauncherJudgment, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LauncherJudgment$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LauncherJudgment' from JSON`,
  );
}
